import {BasicManagedFile} from './basicManagedFile'
import {USR, USR_INSP} from '../Data/typeDirs'
import {genId} from '../utils'

export default class User extends BasicManagedFile {
  // static getIndices(){
  //   return '_id,username,firstName,lastName,role'
  // }

  constructor(data){
    super(data)
    this.typeDir = User.getTypeDir()
    this.ext = 'usr.json'
  }
  static getTypeDir(){
    return USR
  }

  static getPopulates(){
    return[
      'inspections'
    ]
  }

  static initialize(userInfoSchema, userDataSchema, roles, userInspections = []){
    return {
      userInfo: {
        schema: userInfoSchema,
        source: {
          roles
        },
        tree:{}
      },
      userData: {
        schema: userDataSchema,
        source: {
          userInspections
        },
        tree:{}
      }
    }
  }

  async getInspectionList(dataSource){

    // if( !this.content || !this.content.getData ){
    //   throw new Error('User: can\'t get inspection list: not initialized')
    // }
    // const data = this.content.getData(true)
    // const {userData} = data
    // userData.tree.inspList = userData.tree.inspList.content? userData.tree.inspList: {content: []}
    // return userData.tree.inspList.content

    let inspList = await dataSource('remDb')[USR_INSP].get({_user:this._id})
    console.log('got inspList from db', inspList)

    if(Array.isArray(inspList)){
      return inspList.map(itm=>{
        return itm._inspection
      })
    }
    else return [inspList._inspection]

  }

  getPrettyName(){
    let first = this.content.getValue('userInfo', 'firstName')[0]._name
    let last = this.content.getValue('userInfo', 'lastName')[0]._name
    let username = this.content.getValue('userInfo', 'username')[0]._name
    return `${first} ${last} (${username})`
  }

  async assignInspection(inspId, dataSource){

    // let inspList = this.getInspectionList(dataSource)
    let inspList = await this.getInspectionList(dataSource)
    console.log('got insp list', inspList)
    if( !Array.isArray(inspList) ){
        inspList = [inspList]
    }
    if( !inspList.includes(inspId) ){
      let ref = {_id:genId(), _user:this._id, _inspection:inspId}
      console.log('id not found in insp list putting', ref)
      await dataSource('remDb')[USR_INSP].put(ref)
      inspList.push(inspId)
      this.inspections = inspList
      // let data = this.content.getData(true)
      // console.log('got data in user', data)
      // data.userData.tree.inspList = data.userData.tree.inspList || {content: []}
      // data.userData.tree.inspList.content = inspList
      let me = this
      // me.content = data
      return this.construct(me)
    }
    return null
  }

  async unassignInspection(inspId, dataSource){
    if( !this.content || !this.content.getData ){
      throw new Error('User: can\'t unassign inspection: not initialized')
    }

    let inspList = await this.getInspectionList(dataSource)
    console.log('unassigning inspection', inspId, inspList)
    inspList = inspList.filter(itm=>itm!==inspId)
    let recExists = await dataSource('remDb')[USR_INSP].get({_inspection:inspId, _user:this._id})
    console.log('recExists', recExists)
    if(recExists._id){
      await dataSource('remDb')[USR_INSP].kill(recExists._id)
    }
    this.inspections = inspList

    // const data = this.content.getData(true)
    // const {userData} = data
    // console.log('in unassign with userData', userData)
    // userData.tree.inspList.content = userData.tree.inspList.content || []
    // if( !Array.isArray(userData.tree.inspList.content) ) {
    //   userData.tree.inspList.content = [userData.tree.inspList.content]
    // }
    // let didModify = false
    // userData.tree.inspList.content = userData.tree.inspList.content.filter(elm => {
    //   if( elm === inspId ){
    //     didModify = true
    //     return false
    //   }
    //   return true
    // })
    // if( didModify ){
    //   data.userData = userData
    //   let me = this
    //   me.content = data
    //   return this.construct(me)
    // } else {
    //   return null
    // }
  }

  setInspList(inspList = []){
    if( !this.content || !this.content.userData || !this.content.userData.source ){
      throw new Error('User: can\'t add inspection list: not initialized')
    }
    this.content.userData.source = this.content.userData.source || {}
    this.content.userData.source.userInspections = inspList
    return this
  }
}
